module.exports = __webpack_public_path__ + "img/agency-cart-abandonment.12a9b658.svg";